export const checkinMisc = {
  authorityBadges: {
    states: {
      ok: "Erfolgreich gesendet",
      error: "Übermittlungsfehler",
      notConfigured: "Nicht konfiguriert",
      pending: "Übermittlung ausstehend",
    },
    errorNoInfo: "Fehler (keine Details)",
  },
  msgPolice: {
    title: "Information",
    pendingSyncText:
      "Die Check-in-Daten warten noch auf die Synchronisierung; sie werden an dem Tag an die örtlichen Behörden übermittelt, an dem der Gast in der Unterkunft ankommt.",
    entryDateLabel: "Ankunftsdatum:",
    syncedText:
      "Die Daten des Gastes {name} wurden erfolgreich mit den örtlichen Behörden synchronisiert.",
    syncDateLabel: "Datum der Synchronisierung:",
    errorText:
      "Aus externen Gründen konnte die Synchronisierung mit den örtlichen Behörden nicht abgeschlossen werden.",
    close: "Schließen",
  },
};
